module.exports = __webpack_public_path__ + "media/images/icons/dots_vertical-773d104731d05461e6af786c48e48281.svg";